export const MEDIA_QUERY_LD = "@media screen and (max-width: 991px)";
export const MEDIA_QUERY_MD = "@media screen and (max-width: 720px)";
export const MEDIA_QUERY_SD = "@media screen and (max-width: 540px)";

// import {MEDIA_QUERY_LD, MEDIA_QUERY_MD, MEDIA_QUERY_SD}
